import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledSequenceGoalContainer = styled(Box, {
  display: 'flex',
  gap: '$3',
  width: '100%',
});

export const StyledSequenceGoalDetail = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  whiteSpace: 'nowrap',
});
